import { DesktopItemType, DockItemType } from './provider';

const OLD_KEY = 'finsight_dashboard_config';
const NEW_DOCK_KEY = 'blackframe.ui.dockitems';
const NEW_DESKTOP_KEY = 'blackframe.ui.desktop';

type OldSchema = {
  cards: Array<{
    type: string;
    entityId: string;
    id: string;
    order: number;
    workspaceId?: string;
  }>;
  version: number;
  dockItems: Array<{
    type: string;
    entityId: string;
    workspaceId?: string;
    name: string;
    icon?: string;
  }>;
};

function loadFromOldSchema(): {
  dockItems: DockItemType[];
  desktopItems: DesktopItemType[];
} | null {
  const oldData = localStorage.getItem(OLD_KEY);
  if (!oldData) return null;

  try {
    const parsed: OldSchema = JSON.parse(oldData);

    // Convert old dockItems to new format
    const dockItems: DockItemType[] = parsed.dockItems.map((item) => ({
      label: item.name,
      image: item.icon,
      type: 'entity',
      entityId: item.entityId,
      workspaceId: item.workspaceId ?? '',
    }));

    // Convert old cards to new desktop format
    const desktopItems: DesktopItemType[] = parsed.cards.map((card) => ({
      label: card.entityId, // We don't have the name in cards, using entityId as fallback
      position: card.order,
      type: 'entity',
      entityId: card.entityId,
      workspaceId: card.workspaceId ?? '',
    }));

    return { dockItems, desktopItems };
  } catch {
    return null;
  }
}

export function loadDockItems(): DockItemType[] {
  const defaultDockItems: DockItemType[] = [
    {
      image: 'icon:help_outlined',
      label: 'Scratchpad',
      type: 'link',
    },
    {
      image: 'icon:home',
      label: 'Home',
      type: 'link',
    },
    {
      label: 'Projects',
      type: 'link',
    },
    {
      label: 'Items',
      type: 'link',
    },
  ];

  const newData = localStorage.getItem(NEW_DOCK_KEY);
  if (newData) {
    try {
      return JSON.parse(newData);
    } catch {
      return defaultDockItems;
    }
  }

  // Fallback to old schema
  const oldData = loadFromOldSchema();
  return oldData?.dockItems ?? defaultDockItems;
}

export function loadDesktopItems(): DesktopItemType[] {
  const defaultDesktopItems: DesktopItemType[] = [
    {
      image: 'icon:help_outlined',
      label: 'Scratchpad',
      type: 'link',
    },
    {
      image: 'icon:home',
      label: 'Home',
      type: 'link',
    },
    {
      label: 'Projects',
      type: 'link',
    },
    {
      label: 'Items',
      type: 'link',
    },
  ];

  const newData = localStorage.getItem(NEW_DESKTOP_KEY);
  if (newData) {
    try {
      return JSON.parse(newData);
    } catch {
      return defaultDesktopItems;
    }
  }

  // Fallback to old schema
  const oldData = loadFromOldSchema();
  return oldData?.desktopItems ?? defaultDesktopItems;
}

export function saveDockItems(items: DockItemType[]): void {
  localStorage.setItem(NEW_DOCK_KEY, JSON.stringify(items));
}

export function saveDesktopItems(items: DesktopItemType[]): void {
  localStorage.setItem(NEW_DESKTOP_KEY, JSON.stringify(items));
}
